export default __webpack_public_path__ + "static/media/header-container-red.f79ea1ca.png";